import { render } from "./PatientFormPage.vue?vue&type=template&id=0c1ee25f&ts=true"
import script from "./PatientFormPage.vue?vue&type=script&lang=ts"
export * from "./PatientFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Patient/PatientFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c1ee25f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c1ee25f', __exports__)) {
    api.reload('0c1ee25f', __exports__)
  }
  
  module.hot.accept("./PatientFormPage.vue?vue&type=template&id=0c1ee25f&ts=true", () => {
    api.rerender('0c1ee25f', render)
  })

}


export default __exports__